import { createFileRoute, notFound } from '@tanstack/react-router'

/**
 * Catch-all for unmatched paths under /$projectId (e.g. /$projectId/test).
 * Throws notFound() which bubbles to the root notFoundComponent for a
 * full-page 404.
 */
export const Route = createFileRoute('/_app/$projectId/$')({
  beforeLoad: () => {
    throw notFound()
  },
})
